import { InjectionToken } from '@angular/core';
import { BookingConfirmationService } from '../service';

export const BOOKING_CONFIRMATION_SERVICE = new InjectionToken<BookingConfirmationService>('BookingConfirmationService');
